export const FINISH_PRINT = '[LOGOUT] FINISH_PRINT';


// WEBPACK FOOTER //
// ./src/view/constant/PrintConstant.js